import React, { useMemo } from "react";
import useCurrentDealStore from "stores/DealStore";
import { DealStatus } from "constants/Constants";
import useCurrentLeaseStore from "../../../../stores/LeaseStore";
import {
	CurrencyInput,
	IntegerInput,
} from "../../../forms/components/InputElement";

const MarkupInput = () => {
	const lease = useCurrentLeaseStore((state) => ({ ...state }));
	const type = useCurrentDealStore((state) => state.deal.type);
	const totalCost = useCurrentDealStore((state) => state.vehicle.totalCost);

	console.log("totalCost", totalCost);
	// derive multiplier from store so it always reflects current price/totalCost
	const multiplier = useMemo(() => {
		if (!totalCost || totalCost === 0) return 0;
		return (lease.price ?? 0) / totalCost;
	}, [lease.price, totalCost, lease.markup]);

	const readOnly = type !== DealStatus.PENDING;

	const setFromMultiplier = (val) => {
		const m = Number(val) || 0;
		const base = Number(totalCost) || 0;
		const newPrice = base * m;
		lease.editField("price", newPrice);
		lease.editField("markup", newPrice - base);
	};

	const setFromMarkup = (val) => {
		console.log(val);
		const markup = Number(val) || 0;
		const base = Number(totalCost) || 0;
		lease.editField("markup", markup);
		lease.editField("price", base + markup);
	};

	console.log(typeof setFromMarkup);
	return (
		<>
			<IntegerInput
				disableValidation
				value={multiplier}
				onChange={setFromMultiplier}
				name="multiplier"
				label="Multiplier"
				type="number"
				colSize="col-xl-3"
				wholeRow
				decimalScale={8}
				readOnly={readOnly}
			/>
			<CurrencyInput
				disableValidation
				key="markup"
				value={lease.markup ?? 0}
				onChange={setFromMarkup}
				name="markup"
				label="Markup"
				colSize="col-xl-3"
				readOnly={readOnly}
			/>
		</>
	);
};

export default MarkupInput;
